module.exports = __webpack_public_path__ + "static/media/bilda-icon.116f407a.svg";